import Facebook from 'mdi-material-ui/Facebook';
import GithubCircle from 'mdi-material-ui/GithubCircle';
import Linkedin from 'mdi-material-ui/Linkedin';
import Twitter from 'mdi-material-ui/Twitter';

import Avatar from '~/images/people/avatar.svg';

import DefaultImage from '../DefaultImage';
import KeyValueRow from './KeyValueRow';
import SocialLink from './SocialLink';
import styles from './Styles.style';

class Company extends React.Component {
  render() {
    const { response, classes } = this.props;

    return (
      <div className={classes.company}>
        <div className={classes.header}>
          <div className={classes.avatarWrap}>
            <DefaultImage
              className={classes.avatar}
              src={response.company_logo}
              default={Avatar}
            />
          </div>

          <div className={classes.title} title={response.company_name}>
            {response.company_name}
          </div>
        </div>

        {response.company_domain && (
          <KeyValueRow
            label="Domain"
            value={response.company_domain}
            link={`http://${response.company_domain}`}
          />
        )}

        {response.company_description && (
          <KeyValueRow
            label="Description"
            value={response.company_description}
          />
        )}

        {response.company_legal_name && (
          <KeyValueRow label="Legal Name" value={response.company_legal_name} />
        )}

        {response.company_revenue && (
          <KeyValueRow
            label="Company Revenue (est)"
            value={response.company_revenue}
          />
        )}

        {response.company_size && (
          <KeyValueRow label="Company Size" value={response.company_size} />
        )}

        {response.company_location && (
          <KeyValueRow
            label="Company Location"
            value={response.company_location}
          />
        )}

        <div className={classes.socialBar}>
          {response.company_twitter && (
            <SocialLink
              href={`https://twitter.com/${response.company_twitter}`}>
              <Twitter />
            </SocialLink>
          )}

          {response.company_facebook && (
            <SocialLink
              className={classes.socialIcon}
              href={`https://facebook.com/${response.company_facebook}`}>
              <Facebook />
            </SocialLink>
          )}

          {response.company_github && (
            <SocialLink href={`https://github.com/${response.company_github}`}>
              <GithubCircle />
            </SocialLink>
          )}

          {response.company_linkedin && (
            <SocialLink
              href={`https://linkedin.com/${response.company_linkedin}`}>
              <Linkedin />
            </SocialLink>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Company);
